import { render } from 'inferno';
import App from './App';
import './index.css';

render(<App />, document.getElementById('app'));
